export default __webpack_public_path__ + "static/media/Poppins-Medium.b59f6a63.ttf";